import { render } from "./ValidationRule.vue?vue&type=template&id=02c27a84&scoped=true"
import script from "./ValidationRule.vue?vue&type=script&lang=js"
export * from "./ValidationRule.vue?vue&type=script&lang=js"

import "./ValidationRule.vue?vue&type=style&index=0&id=02c27a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c27a84"]])

export default __exports__